export default __webpack_public_path__ + "locales/vi/Ldap.json?hash=51109da5d867a3ab4c24b76167508234";